module.exports = __webpack_public_path__ + "img/pethouse41.11c6da9e.jpg";